/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscrepancyRequest } from '../../models/discrepancy-request';
import { DiscrepancyResponse } from '../../models/discrepancy-response';
import { KeyType } from '../../models/key-type';

export interface PostNewDiscrepancy$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
      body: DiscrepancyRequest
}

export function postNewDiscrepancy(http: HttpClient, rootUrl: string, params: PostNewDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscrepancyResponse>> {
  const rb = new RequestBuilder(rootUrl, postNewDiscrepancy.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscrepancyResponse>;
    })
  );
}

postNewDiscrepancy.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/discrepancies';
